import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.4354 3.30005C15.1048 3.30005 13.879 3.84037 12.9515 4.72747L15.1532 6.92908L11.5241 10.5581L14.7499 13.7839L11.758 16.7759L10.6209 15.6388L12.4677 13.792L9.24186 10.5662L12.8709 6.93715L10.5644 4.63069C9.77412 3.84037 8.70961 3.31618 7.58864 3.31618C7.58864 3.31618 7.57251 3.31618 7.56445 3.31618C4.67735 3.30005 2.32251 5.83231 2.32251 8.94521C2.32251 14.5259 11.1612 20.7194 11.5403 20.9775L11.9999 21.3L12.4596 20.9775C12.8386 20.7194 21.6773 14.5259 21.6773 8.94521C21.6773 5.83231 19.3225 3.30005 16.4354 3.30005Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgAccountClose);
export default ForwardRef;
